import { render, staticRenderFns } from "./MobileDosDonts.vue?vue&type=template&id=8f38344c&"
import script from "./MobileDosDonts.vue?vue&type=script&lang=js&"
export * from "./MobileDosDonts.vue?vue&type=script&lang=js&"
import style0 from "./MobileDosDonts.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports